const content = {
    tesco_data_upload: {
        en: {
            summary_no_video_html: `
                <p>To upload your Clubcard Data — the data that you downloaded in part one, simply follow the instructions below:</p>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: `
                    <p>Navigate to where you downloaded your Clubcard Data. Typically this is in your "Downloads" folder, on either your
                        phone or your desktop/laptop.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: `
                        <p>Upload your file below.</p>`
                },
            ],
            finished_steps_text: 'I have my Tesco data ready for upload',
        }
    }
}

export const tescoDataTypes = {
    tesco_data_upload: {
        data_type: 'tesco_data_upload',
        data_type_description: 'Tesco Data Upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/tesco/logo.png',
        capture_type: 'file',
        ios: {
            use_in_app_screen_recorder: false,
            ...content.tesco_data_upload
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.tesco_data_upload,
        }
    },
}